// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import CheckInAction from './data'

export default function CheckInActionFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/CheckInAction">
      <CheckInAction {...props}>
        {children}
      </CheckInAction>
    </Flow>
  )
}
